import { useMemo } from 'react';

import { FormContextValues, useFormController } from '@dreryk/react-common';
import { Form } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { NoteTextarea, NoteValue } from './NoteTextarea';

export type AppointmentNoteFormBean = { note: NoteValue };

type AppointmentNoteFormController = FormContextValues<AppointmentNoteFormBean>;
type AppointmentNoteManagementFormInitializer = () => AppointmentNoteFormBean;

type AppointmentNoteFormRenderer = (renderProps: Pick<AppointmentNoteFormController, 'handleSubmit'>) => JSX.Element;

type AppointmentNoteFormProps = {
   readonly children: AppointmentNoteFormRenderer;
   readonly initializer: AppointmentNoteManagementFormInitializer;
};

export const AppointmentNoteManagementForm = (props: AppointmentNoteFormProps): JSX.Element => {
   const { initializer } = props;
   const { register, handleSubmit } = useFormController<AppointmentNoteFormBean>(
      useMemo(() => initializer(), [initializer])
   );

   return (
      <>
         <Form>
            <NoteTextarea register={register} label={translationKeys.noteManagement.form.note.label} />
         </Form>

         {props.children({
            handleSubmit: handleSubmit,
         })}
      </>
   );
};
